

    <p-card  *ngIf="caseFilesWithoutService.length > 0" styleClass=" p-card-content-no-padding">
        <ng-template pTemplate="header">
            <div class="p-card-title flex gap-2">
                Sin sevicio
              <div class="flex-grow-1"></div>
              <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox (onChange)="selectAll($event, null)" [binary]="true"  />Seleccionar todos</label>
            </div>
          </ng-template>
        <div class="grid">
            <div *ngFor="let file of caseFilesWithoutService; let  i = index" class="col-2">
                <div *ngIf="fileIsAnImage(file.file)"
                    style="border: 1px solid #e9e9e9; padding: 10px; border-radius: 10px;">
                    <img [d-img-lazy]="imagesUrl + file.fileId + '/thumbnail'" alt="{{file.file.fileName}}"
                        class="w-full" />
                    <div class="flex justify-content-between align-items-center mt-1">
                        <span>{{file.index}}.&nbsp;{{file.file?.caseFileCategory?.name}}</span>
                        <p-checkbox (onChange)="selectFile(file.fileId, 'empty')" [(ngModel)]="caseFilesIdToPDFChecked['empty']" [value]="file.fileId"  />
                    </div>
                </div>
            </div>
        </div>
    </p-card>

    <p-card *ngFor="let service of caseFilesServices" styleClass="mt-4  p-card-content-no-padding">
        <ng-template pTemplate="header">
            <div class="p-card-title flex gap-2">
                {{service.name}} 
              <div class="flex-grow-1"></div>
              <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox (onChange)="selectAll($event, service.id)"  [binary]="true"   />Seleccionar todos</label>
         
            </div>
          </ng-template>
        <div class="grid">
            <div *ngFor="let file of filesByService(service.id);let  i = index" class="col-2">
                <div *ngIf="fileIsAnImage(file.file)"
                    style="border: 1px solid #e9e9e9; padding: 10px; border-radius: 10px;">
                    <img [d-img-lazy]="imagesUrl + file.fileId + '/thumbnail'" alt="{{file.file.fileName}}"
                        class="w-full" />
                    <div class="flex justify-content-between align-items-center mt-1">
                        <span>{{file.index}}.&nbsp;{{file.caseFileCategory?.name}}</span>
                        <p-checkbox  (onChange)="selectFile(file.fileId, service.id)" [(ngModel)]="caseFilesIdToPDFChecked[service.id]"  [value]="file.fileId" />
                        
                    </div>
                </div>
            </div>
        </div>
    </p-card>


    <p-card styleClass="mt-4 p-card-content-no-padding">
        <ng-template pTemplate="header">
            <div class="p-card-title flex gap-2">
                Opción de informe fotográfico
            </div>
          </ng-template>
        <div class="flex flex-column gap-2">
          
          <div class="input-field">
            <label for="description">Descripción</label>
            
            <textarea pInputTextarea rows="3" [(ngModel)]="photoInfo.description" d-form-field-error></textarea>
        </div>

            <div class="input-field">
                <label for="date">Número de fotos por página</label>
                <p-dropdown [(ngModel)]="photoInfo.num_images" [options]="numberPages"
                    [ngModelOptions]="{ standalone: true }" showClear name="num_images" appendTo="body" optionLabel="name"
                    optionValue="id" ></p-dropdown>
            </div>
            <div class="input-field">
                <label for="landscape">Orientación</label>
                <p-dropdown [(ngModel)]="photoInfo.landscape" [options]="arrayYesNoLandscape"
                    [ngModelOptions]="{ standalone: true }" showClear name="yesNo" appendTo="body" optionLabel="name"
                    optionValue="id" ></p-dropdown>
            </div>
            <div class="input-field">
                <label for="logo">Mostrar logo de compañía</label>
                <p-dropdown [(ngModel)]="photoInfo.logo" [options]="arrayYesNo"
                    [ngModelOptions]="{ standalone: true }" showClear name="yesNo" appendTo="body" optionLabel="name"
                    optionValue="id" ></p-dropdown>
            </div>
            <div class="input-field">
                <label for="code">Mostrar expediente</label>
                <p-dropdown [(ngModel)]="photoInfo.code" [options]="arrayYesNo"
                    [ngModelOptions]="{ standalone: true }" showClear name="yesNo" appendTo="body" optionLabel="name"
                    optionValue="id" ></p-dropdown>
            </div>
            <div class="input-field">
                <label for="description">Mostrar descripción en cada foto</label>
                <p-dropdown [(ngModel)]="photoInfo.has_description_images" [options]="arrayYesNo"
                    [ngModelOptions]="{ standalone: true }" showClear name="yesNo" appendTo="body" optionLabel="name"
                    optionValue="id" ></p-dropdown>
            </div>
        </div>
    </p-card>

    <p-footer>
        <div class="pt-3 flex">
            <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="cancel()"></button>
            <div class="flex-grow-1"></div>
            <button pButton label="Generar" icon="pi pi-check" (click)="showFilesDocument()"></button>
        </div>
    </p-footer>


<p-dialog header="Documento" [(visible)]="displayFramePhoto" [modal]="true" [closable]="false"
    [style]="{width: '1200px'}">
    
    <iframe id="case-file-preview" src="about:blank" height="500" width="100%"></iframe>

    <div class="pt-3 flex flex-column gap-2">
        <div class="input-field">
            <label for="thidPartyType">Seleccione a quién mandar email</label>
            <p-dropdown [(ngModel)]="thirdPartiesSendEmail.thidPartyType" 
                [options]="thirdPartyOptions" (onChange)="changeThirdParty($event)"
                [ngModelOptions]="{ standalone: true }" showClear 
                name="thidPartyType" appendTo="body" optionLabel="name"
                placeholder="Seleccione"
                optionValue="id" ></p-dropdown>
        </div>
        <div class="input-field" *ngIf="thirdPartiesSendEmail.thidPartyType!='other'&&thirdPartiesSendEmail.thidPartyType!='company'">
            <label for="thirdPartyId">Seleccione</label>
            <p-dropdown [(ngModel)]="thirdPartiesSendEmail.thirdPartyId" [options]="thirdParties"
                [ngModelOptions]="{ standalone: true }" showClear name="thirdPartyId"
                (onChange)="selectThirdParty($event)"
                 appendTo="body" optionLabel="name"
                optionValue="id" ></p-dropdown>
        </div>
        <div class="input-field">
            <label for="email">Email</label>
            <input pInputText placeholder="mail@mail.com" [(ngModel)]="thirdPartiesSendEmail.email"  class="w-full" />
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="pt-3">
            <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="displayFramePhoto=false"></button>
            <button pButton label="Enviar email" icon="pi pi-envelope" (click)="saveMailAndSend()"></button>
        </div>
    </ng-template>
</p-dialog>
